// extracted by mini-css-extract-plugin
export default {"message":"AriaLive-module__message___KghZQ"};